export default {
  imgAlt: "Klinika LLC - Plastická chirurgie, Laserová a estetická chirurgie, Všeobecná a žilní chirurgie, Interna a obezitologie, Kožní lékařství, ORL"
}



// WEBPACK FOOTER //
// ./src/texts/general/imgAlt.js